import { createI18n } from "vue-i18n";
import tr from "./locales/tr.json";
import en from "./locales/en.json";

// Type-define 'messages' for better type safety
const messages = {
  tr,
  en,
};

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: "tr", // Default locale
  fallbackLocale: "en", // Fallback locale
  globalInjection: true, // Allow usage of $t in template
  messages,
});

export default i18n;
